import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Icon, ButtonWithIcon, DropArea, InputFileButton, CropTool } from 'scorer-ui-kit';
import { useTranslation } from 'react-i18next';

const DropAreaContainer = styled.div`
  text-align: center;
  width: 100%;
  position: relative;
  background-color: #e3ecf1;
`;

const DropWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 351px;
  width: 100%;
`;

const IconWrapper = styled.div`
  padding: 45px 0px 22px 0px;
`;

const FloorTitle = styled.div`
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 20px;
  font-weight: 500;
  text-align: center;
  color: #5a6269;
`;

const FloorText = styled.div`
  padding: 28px 0px 22px 0px;
  font-family: ${({ theme }) => theme.fontFamily.ui};
  font-size: 14px;
  font-style: italic;
  line-height: 1.79;
  text-align: center;
  color: #8b9196;
`;

const InputFileWrapper = styled.div`
  margin: 5px auto 57px auto;
  z-index: 3;
  position: inherit;
`;

const FloorPlanComponent = styled.div<{ isImage: boolean }>`
  display: flex;
  flex-direction: column;
  width: inherit;
  height: auto;
  border-radius: 5px;
`;

const Buttons = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 11px 0 0 0;
`;

const CropImage = styled.img`
  width: 100%;
  height: 351px;
  object-fit: contain;
  border-radius: 5px;
  background-color: #e3ecf1;
`;

const IconButton = styled(ButtonWithIcon)`
  background-color: #f8f8f8;
`;

const RemoveButton = styled(IconButton)`
  margin-right: 15px;
`;

const UploadImage = ({ image, onImageChange, onCroppedImageChange, croppedImage }: any) => {
  const [isCropping, setIsCropping] = useState(false);

  const { t } = useTranslation(['SetupFloorplan', 'Common']);

  const options = {
    title: t('crop_floor_plan'),
    cancelBtnTxt: t('cancel'),
    cropBtnTxt: t('crop_save'),
    isResizable: true,
    canvasHeight: 550,
    canvasWidth: 761,
    cropHeight: 400,
    cropWidth: 400,
    aspectRatio: 0,
  };

  //アップロードされたオリジナル背景画像をBase64化して保存（他と同じ仕様）
  const convertFileToBase64 = (file: any) => {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = reject;
      }
      catch (err) {
        console.log('error for baseto64');
      }
    });
  };
  const onDrop = useCallback(async(files) => {
    onImageChange(await convertFileToBase64(files[0]));
    setIsCropping(true);
  }, [onImageChange]);
  const onChangeImage = useCallback(async(files) => {
    onImageChange(await convertFileToBase64(files[0]));
    setIsCropping(true);
  }, [onImageChange]);

  

  const onRemove = () => {
    onImageChange(null);
    onCroppedImageChange(null);
  };

  const onCrop = useCallback((img) => {
    onCroppedImageChange(img);
    setIsCropping(false);
  }, [onCroppedImageChange]);

  const onClickCrop = useCallback(() => {
    setIsCropping(true);
  }, []);

  const onClose = () => {
    setIsCropping(false);
  };

  return (
    <FloorPlanComponent isImage={image != null}>
      {
        croppedImage ?
          <>
            <CropImage id='floor-img' src={croppedImage} alt='floor_image' onError={() => onImageChange(null)} />
            <Buttons>
              <RemoveButton size='small' icon='Delete' position='left' design='secondary' onClick={onRemove} disabled={image ? false : true}>
                {t('Common:remove')}
              </RemoveButton>
              <IconButton size='small' icon='Crop' position='left' design='secondary' onClick={onClickCrop}> {t('crop')} </IconButton>
            </Buttons>
          </> :
          <DropAreaContainer>
            <IconWrapper>
              <Icon icon='Zone' size={62} color='dimmed' />
            </IconWrapper>
            <FloorTitle>{t('Common:floorplan_image')}</FloorTitle>
            <FloorText>{t('Common:drag_title')} <br />{t('Common:drag_subtitle')}</FloorText>
            <InputFileWrapper>
              <InputFileButton text={t('Common:select_file')} buttonSize='small' inputCallback={onChangeImage} />
            </InputFileWrapper>
            <DropWrapper>
              <DropArea
                height='351px'
                dropCallback={onDrop}
              />
            </DropWrapper>
          </DropAreaContainer>
      }
      {isCropping &&
        <CropTool
          key={image}
          imgUrl={image}
          onCrop={onCrop}
          onClose={onClose}
          {...options}
        />}
    </FloorPlanComponent>
  );
};

export default UploadImage;